<template>
  <div class="page" :data-route-name="$route.name">
    <header class="page__header">
      <page-container>
        <div class="page__header__inner">
          <div class="header-item header-item--left">
            <slot name="headerLeft">
              <PageLogo />
            </slot>
          </div>

          <div class="header-item header-item--center">
            <slot name="headerCenter" />
          </div>

          <div class="header-item header-item--right">
            <slot name="headerRight">
              <AccountControls v-if="isAuthenticated" />
              <BurgerMenu v-if="isAuthenticated" />
            </slot>
          </div>
        </div>
      </page-container>
    </header>
    <!-- Use the dynamic class to customize its CSS -->
    <main class="page__main" :class="[`page__main--${$route.name}`]">
      <page-container>
        <slot />
      </page-container>
    </main>
    <footer v-if="hasFooter" class="page__footer">
      <page-container>
        <slot name="footer" />
      </page-container>
    </footer>
  </div>
</template>

<script>
import PageContainer from '@/layout/components/PageContainer.vue';
import AccountControls from '@/components/AccountControls.vue';
import BurgerMenu from '@/components/BurgerMenu.vue';
import PageLogo from '@/components/PageLogo.vue';
import { GETTER } from '@/store/CONSTANTS';

export default {
  name: 'PageBase',
  components: {
    PageContainer,
    AccountControls,
    BurgerMenu,
    PageLogo,
  },
  computed: {
    hasFooter() {
      return Boolean(this.$slots.footer);
    },
    isAuthenticated() {
      return this.$store.getters[GETTER.USER.AUTHENTICATED];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.page {
  display: flex;
  flex-direction: column;
  align-items: stretch;

  &__header {
    background-color: getShade($primary-color, 110);
    position: sticky;
    top: 0;
    z-index: 30;
    box-shadow: 0 5px 5px 2px $primary-bg;
    margin-bottom: $sp-s;
    padding: $sp-s + $sp-xxs 0;
    height: $header-height-mobile;
    @include elevation(1);

    @include for('tablet') {
      height: $header-height;
      margin-bottom: $sp-m;
    }

    &__inner {
      align-items: center;
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    .page-container {
      display: flex;
      max-width: 100%;
      padding: 0 $sp-m;
    }
  }

  .header-item {
    &--left {
      flex: 1;
      justify-content: flex-end;
      max-width: 50%;
    }
    &--right {
      align-items: center;
      display: flex;
      flex: 1;
      gap: calc(#{$sp-m} + #{$sp-xs});
      justify-content: flex-end;
      max-width: 50%;
    }
  }

  &__main {
    flex-grow: 1;
  }
}
</style>
